import React from 'react';
import { 
  ListItem, 
  Box, 
  Typography, 
  useTheme
} from '@mui/material';
import { formatCurrency } from '../utils/lib';
import { useTranslation } from 'react-i18next';

const DailyCashDetailsItem = ({ item }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const getTypeLabel = (type) => {
    switch(type) {
      case "SELL": return t('dailyCash.sellIncomes');
      case "MANUAL_CASH_IN": return t('dailyCash.manualIncomes');
      case "MANUAL_CASH_OUT": return t('dailyCash.manualExpenses');
      case "PURCHASE": return t('dailyCash.purchaseExpenses');
      case "SPENDING": return t('dailyCash.spendings');
      default: return type;
    }
  };

  const getTypeColor = (type) => {
    switch(type) {
      case "SELL": return theme.palette.success.main;
      case "MANUAL_CASH_IN": return theme.palette.success.main;
      case "MANUAL_CASH_OUT": return theme.palette.error.main;
      case "PURCHASE": return theme.palette.error.main;
      case "SPENDING": return theme.palette.error.main;
      default: return theme.palette.grey[500];
    }
  };

  return (
    <ListItem sx={{ py: 2 }}>
      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: getTypeColor(item.type) }}>
            {getTypeLabel(item.type)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {item.name}
          </Typography>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: getTypeColor(item.type) }}>
          {formatCurrency(item.amount)}
        </Typography>
      </Box>
    </ListItem>
  );
};

export default DailyCashDetailsItem; 